const SKILL_ICON_COLOR_PALETTE_DARK = ['#B7BDC7', '#3A3D44', '#5D7CFF', '#2BB8DA', '#53D2A8', '#F1C700', '#F3A44B', '#E8BFB8', '#F16464'];
const SKILL_ICON_COLOR_PALETTE_LIGHT = ['#5F6B7A', '#2C2E33', '#2D4BD4', '#0E7A9A', '#1E906B', '#A88700', '#B86E28', '#966F67', '#BE3333'];
/* Plain names for the swatches, by position. The picker shows bare swatches, but the analytics
   assistant is asked for colours by name ("make the icon green"), so its tool lists each stored
   dark-palette value beside the name it answers to. */
const SKILL_ICON_COLOR_NAMES = ['gray', 'charcoal', 'blue', 'cyan', 'green', 'yellow', 'orange', 'rose', 'red'];

const SKILL_ICON_INTENT_MAP = {
  cube: 'General purpose utility skill.',
  smile: 'Friendly, positive, or customer-delight workflows.',
  frown: 'Incident follow-ups, complaints, or negative sentiment handling.',
  star: 'Priority, featured, or default workflows.',
  heart: 'People care, community, or wellbeing workflows.',
  plus: 'Create, add, or onboarding workflows.',
  bolt: 'Automation, execution, and fast actions.',
  fire: 'Urgent, high-priority, or high-impact workflows.',
  leaf: 'Sustainability, wellness, or lightweight workflows.',
  cloud: 'Cloud services, sync, or hosted systems.',
  sun: 'Daytime, daily cadence, or optimistic workflows.',
  moon: 'Nightly jobs, off-hours, or quiet mode workflows.',
  rocket: 'Launches, growth, shipping, and acceleration workflows.',
  plane: 'Travel and trip operations workflows.',
  car: 'Driving, fleet, and local mobility workflows.',
  train: 'Transit, rail, and route scheduling workflows.',
  ship: 'Logistics, shipping, freight, and delivery workflows.',
  anchor: 'Stability, grounding, and long-term reliability workflows.',
  bicycle: 'Cycling, lightweight transport, or activity workflows.',
  bug: 'Bugs, defects, QA, and debugging workflows.',
  code: 'Engineering, scripts, and development workflows.',
  terminal: 'CLI, shell commands, and operations workflows.',
  database: 'Data storage, records, and SQL workflows.',
  server: 'Infrastructure, backend services, and runtime workflows.',
  gear: 'Configuration, settings, and system management workflows.',
  wrench: 'Maintenance, repair, and tooling workflows.',
  hammer: 'Governance, enforcement, and compliance workflows.',
  lock: 'Privacy, access control, and secure operations workflows.',
  key: 'Credentials, keys, auth setup, and provisioning workflows.',
  shield: 'Security protection, risk mitigation, and trust workflows.',
  book: 'Documentation, references, and knowledge workflows.',
  calendar: 'Scheduling, events, and date-driven workflows.',
  clipboard: 'Task tracking, checklists, and process workflows.',
  chart: 'Metrics, analytics, and reporting workflows.',
  'chart-line': 'Trends, performance tracking, and growth analytics workflows.',
  music: 'Audio, media, and creative content workflows.',
  camera: 'Images, capture, and visual content workflows.',
  microphone: 'Voice, transcription, and recording workflows.',
  phone: 'Mobile apps, calls, and device workflows.',
  mail: 'Email, inboxes, notifications, and outreach workflows.',
  globe: 'Web, internet, and global operations workflows.',
  map: 'Location, geodata, and routing workflows.',
  gift: 'Rewards, offers, campaigns, and celebration workflows.',
  crown: 'Leadership, ownership, and executive workflows.',
  trophy: 'Wins, achievements, and success milestone workflows.',
  flag: 'Markers, escalation, and status checkpoint workflows.',
  target: 'Goals, targeting, and objective-driven workflows.',
  search: 'Lookup, discovery, and investigation workflows.',
  folder: 'File organization, directories, and workspace workflows.',
  file: 'Documents, attachments, and record workflows.',
  link: 'Integrations, connectors, and linking workflows.',
  paperclip: 'Attachments, uploads, and supporting files workflows.',
  scissors: 'Cleanup, trimming, deleting, and pruning workflows.',
  paint: 'Editing, rewriting, and content polish workflows.',
  palette: 'Design systems, color, and visual style workflows.',
  lightbulb: 'Ideas, brainstorming, and concept workflows.',
  handshake: 'Partnerships, agreements, and relationship workflows.',
  users: 'Team management, staffing, and access workflows.',
  group: 'Collaboration, group coordination, and org workflows.',
  idea: 'Innovation, experiments, and planning workflows.'
};

const SKILL_ICON_BASE_ENTRIES = [
  { id: 'cube', label: 'Cube', hugeicon: 'CubeIcon' },
  { id: 'smile', label: 'Smile', hugeicon: 'SmileIcon' },
  { id: 'frown', label: 'Frown', hugeicon: 'Sad01Icon' },
  { id: 'star', label: 'Star', hugeicon: 'StarIcon' },
  { id: 'heart', label: 'Heart', hugeicon: 'InLoveIcon' },
  { id: 'plus', label: 'Plus', hugeicon: 'PlusSignIcon' },
  { id: 'bolt', label: 'Bolt', hugeicon: 'ZapIcon' },
  { id: 'fire', label: 'Fire', hugeicon: 'FireIcon' },
  { id: 'leaf', label: 'Leaf', hugeicon: 'Leaf01Icon' },
  { id: 'cloud', label: 'Cloud', hugeicon: 'CloudIcon' },
  { id: 'sun', label: 'Sun', hugeicon: 'Sun01Icon' },
  { id: 'moon', label: 'Moon', hugeicon: 'Moon01Icon' },
  { id: 'rocket', label: 'Rocket', hugeicon: 'Rocket01Icon' },
  { id: 'plane', label: 'Plane', hugeicon: 'PlaneIcon' },
  { id: 'car', label: 'Car', hugeicon: 'Car01Icon' },
  { id: 'train', label: 'Train', hugeicon: 'Train01Icon' },
  { id: 'ship', label: 'Ship', hugeicon: 'CargoShipIcon' },
  { id: 'anchor', label: 'Anchor', hugeicon: 'AnchorIcon' },
  { id: 'bicycle', label: 'Bicycle', hugeicon: 'BicycleIcon' },
  { id: 'bug', label: 'Bug', hugeicon: 'Bug01Icon' },
  { id: 'code', label: 'Code', hugeicon: 'CodeIcon' },
  { id: 'terminal', label: 'Terminal', hugeicon: 'ComputerTerminal01Icon' },
  { id: 'database', label: 'Database', hugeicon: 'Database01Icon' },
  { id: 'server', label: 'Server', hugeicon: 'ServerStack01Icon' },
  { id: 'gear', label: 'Gear', hugeicon: 'Settings01Icon' },
  { id: 'wrench', label: 'Wrench', hugeicon: 'Wrench01Icon' },
  { id: 'hammer', label: 'Hammer', hugeicon: 'LegalHammerIcon' },
  { id: 'lock', label: 'Lock', hugeicon: 'LockIcon' },
  { id: 'key', label: 'Key', hugeicon: 'Key01Icon' },
  { id: 'shield', label: 'Shield', hugeicon: 'Shield01Icon' },
  { id: 'book', label: 'Book', hugeicon: 'Book01Icon' },
  { id: 'calendar', label: 'Calendar', hugeicon: 'Calendar01Icon' },
  { id: 'clipboard', label: 'Clipboard', hugeicon: 'ClipboardIcon' },
  { id: 'chart', label: 'Chart', hugeicon: 'Chart01Icon' },
  { id: 'chart-line', label: 'Chart line', hugeicon: 'ChartBarLineIcon' },
  { id: 'music', label: 'Music', hugeicon: 'MusicNote01Icon' },
  { id: 'camera', label: 'Camera', hugeicon: 'Camera01Icon' },
  { id: 'microphone', label: 'Microphone', hugeicon: 'Mic02Icon' },
  { id: 'phone', label: 'Phone', hugeicon: 'SmartPhone01Icon' },
  { id: 'mail', label: 'Mail', hugeicon: 'Mail01Icon' },
  { id: 'globe', label: 'Globe', hugeicon: 'Globe02Icon' },
  { id: 'map', label: 'Map', hugeicon: 'MapPinIcon' },
  { id: 'gift', label: 'Gift', hugeicon: 'GiftIcon' },
  { id: 'crown', label: 'Crown', hugeicon: 'Crown03Icon' },
  { id: 'trophy', label: 'Trophy', hugeicon: 'Medal01Icon' },
  { id: 'flag', label: 'Flag', hugeicon: 'Flag01Icon' },
  { id: 'target', label: 'Target', hugeicon: 'Target01Icon' },
  { id: 'search', label: 'Search', hugeicon: 'Search01Icon' },
  { id: 'folder', label: 'Folder', hugeicon: 'Folder01Icon' },
  { id: 'file', label: 'File', hugeicon: 'File01Icon' },
  { id: 'link', label: 'Link', hugeicon: 'Link01Icon' },
  { id: 'paperclip', label: 'Paperclip', hugeicon: 'AttachmentIcon' },
  { id: 'scissors', label: 'Scissors', hugeicon: 'Scissor01Icon' },
  { id: 'paint', label: 'Paint', hugeicon: 'PaintBrush01Icon' },
  { id: 'palette', label: 'Palette', hugeicon: 'ColorPickerIcon' },
  { id: 'lightbulb', label: 'Lightbulb', hugeicon: 'BulbIcon' },
  { id: 'handshake', label: 'Handshake', hugeicon: 'Agreement02Icon' },
  { id: 'users', label: 'Users', hugeicon: 'AddTeamIcon' },
  { id: 'group', label: 'Group', hugeicon: 'UserGroupIcon' },
  { id: 'idea', label: 'Idea', hugeicon: 'Idea01Icon' }
];

const SKILL_ICON_CURATED_EXPORT_NAMES = [
  'AddToListIcon',
  'AddressBookIcon',
  'AiChat01Icon',
  'AiGenerativeIcon',
  'AiMagicIcon',
  'AiNetworkIcon',
  'AiProgrammingIcon',
  'AlarmClockIcon',
  'Alert01Icon',
  'AlertCircleIcon',
  'Alien01Icon',
  'Analytics01Icon',
  'AnalyticsUpIcon',
  'AngelIcon',
  'AngryIcon',
  'ApiGatewayIcon',
  'ApiIcon',
  'AppleReminderIcon',
  'Attachment01Icon',
  'Award01Icon',
  'BalloonsIcon',
  'BankIcon',
  'BarcodeScanIcon',
  'BirthdayCakeIcon',
  'BombIcon',
  'BookEditIcon',
  'BookOpen01Icon',
  'Bookmark01Icon',
  'BookmarkAdd01Icon',
  'BotIcon',
  'BrowserIcon',
  'BubbleChatAddIcon',
  'BubbleChatDoneIcon',
  'BubbleChatIcon',
  'Building01Icon',
  'Calendar02Icon',
  'CalendarAdd01Icon',
  'CalendarCheckIn01Icon',
  'Call02Icon',
  'CallIcon',
  'CampfireIcon',
  'Certificate01Icon',
  'ChampionIcon',
  'ChartDecreaseIcon',
  'ChartHistogramIcon',
  'ChartIncreaseIcon',
  'ChartRelationshipIcon',
  'ChatBotIcon',
  'CheckListIcon',
  'CheckmarkBadge01Icon',
  'CheckmarkCircle01Icon',
  'Clapping01Icon',
  'Clock01Icon',
  'CloudDownloadIcon',
  'CloudSavingDone01Icon',
  'CloudServerIcon',
  'CloudUploadIcon',
  'CodeFolderIcon',
  'CodeSquareIcon',
  'Coffee01Icon',
  'CommandLineIcon',
  'Comment01Icon',
  'CommentAdd01Icon',
  'Compass01Icon',
  'ConferenceIcon',
  'Configuration01Icon',
  'Contact01Icon',
  'ContactBookIcon',
  'ContractsIcon',
  'ConversationIcon',
  'CookieIcon',
  'Copy01Icon',
  'CopyLinkIcon',
  'CorporateIcon',
  'CreditCardIcon',
  'CryingIcon',
  'Csv01Icon',
  'DashboardBrowsingIcon',
  'DashboardSquare01Icon',
  'DatabaseAddIcon',
  'DatabaseSettingIcon',
  'DeliveryBox01Icon',
  'DeliveryTruck01Icon',
  'DiamondIcon',
  'DiceIcon',
  'Dollar01Icon',
  'DollarCircleIcon',
  'Download01Icon',
  'EyeIcon',
  'FilterIcon',
  'FingerPrintIcon',
  'FireworksIcon',
  'FlowerIcon',
  'FolderSecurityIcon',
  'GitBranchIcon',
  'GitCommitIcon',
  'GitForkIcon',
  'GitMergeIcon',
  'GitPullRequestIcon',
  'Group01Icon',
  'HealthIcon',
  'IceCream01Icon',
  'IdVerifiedIcon',
  'InboxCheckIcon',
  'InboxIcon',
  'InternetIcon',
  'Invoice01Icon',
  'Joystick01Icon',
  'Key02Icon',
  'LabelIcon',
  'LanguageCircleIcon',
  'LaughingIcon',
  'LicenseDraftIcon',
  'ListViewIcon',
  'LockKeyIcon',
  'MagicWand01Icon',
  'MailAdd01Icon',
  'MailEdit01Icon',
  'MailOpen01Icon',
  'MailReceive01Icon',
  'MailReply01Icon',
  'MailSend01Icon',
  'MarketAnalysisIcon',
  'MeetingRoomIcon',
  'Megaphone01Icon',
  'MessageQuestionIcon',
  'MicroscopeIcon',
  'MoneyAdd01Icon',
  'MountainIcon',
  'NerdIcon',
  'Note01Icon',
  'NoteAddIcon',
  'NoteDoneIcon',
  'NoteEditIcon',
  'Notebook01Icon',
  'Notification01Icon',
  'NotificationBubbleIcon',
  'Package01Icon',
  'PartyIcon',
  'PasswordValidationIcon',
  'Payment01Icon',
  'Pdf01Icon',
  'PenTool01Icon',
  'PinIcon',
  'Pizza01Icon',
  'PlayIcon',
  'PopcornIcon',
  'PotionIcon',
  'PrinterIcon',
  'ProfileIcon',
  'ProfitIcon',
  'PuzzleIcon',
  'RainbowIcon',
  'ReceiptDollarIcon',
  'RecordIcon',
  'Refresh01Icon',
  'RepeatIcon',
  'RepositoryIcon',
  'Robot01Icon',
  'Route01Icon',
  'SentIcon',
  'Share01Icon',
  'Share02Icon',
  'ShoppingBag01Icon',
  'ShoppingCart01Icon',
  'SignatureIcon',
  'SkullIcon',
  'SortingIcon',
  'SpamIcon',
  'SparklesIcon',
  'Stamp01Icon',
  'StickyNote01Icon',
  'StopWatchIcon',
  'Store01Icon',
  'SunglassesIcon',
  'Sushi01Icon',
  'Tag01Icon',
  'Task01Icon',
  'TaskAdd01Icon',
  'TaskDone01Icon',
  'TaskEdit01Icon',
  'TaxesIcon',
  'TelescopeIcon',
  'TestTube01Icon',
  'ThumbsUpIcon',
  'Timer01Icon',
  'TranslateIcon',
  'Tree01Icon',
  'Upload01Icon',
  'UserAdd01Icon',
  'UserCheck01Icon',
  'UserSearch01Icon',
  'UserSettings01Icon',
  'UserShield01Icon',
  'UserSwitchIcon',
  'VictoryFinger01Icon',
  'Video01Icon',
  'VolumeHighIcon',
  'Wallet01Icon',
  'Watch01Icon',
  'WaveIcon',
  'WebhookIcon',
  'Wifi01Icon',
  'WinkIcon',
  'WorkflowCircle01Icon',
  'WorkflowSquare01Icon',
  'Yoga01Icon',
  'ZoomIcon'
];

/* The stored icon id for a curated hugeicon export name ('ChartIncreaseIcon' -> 'chart-increase').
   This transform IS the id format of page.meta.icon and skill icons: the renderer catalog and the
   API-side validators both derive ids through it, so an id one side accepts cannot be an id the
   other side fails to draw. */
const toSkillIconOptionId = (exportName = '') => {
  const name = String(exportName || '');

  if (!name.endsWith('Icon')) {
    return '';
  }

  return name
    .slice(0, -4)
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .replace(/_+/g, '-')
    .toLowerCase();
};

/* Every valid stored icon id: the base entries' own ids plus the curated names' derived ids. */
const SKILL_ICON_OPTION_IDS = [...new Set([...SKILL_ICON_BASE_ENTRIES.map((entry) => entry.id), ...SKILL_ICON_CURATED_EXPORT_NAMES.map(toSkillIconOptionId).filter(Boolean)])];

export { SKILL_ICON_COLOR_PALETTE_DARK, SKILL_ICON_COLOR_PALETTE_LIGHT, SKILL_ICON_COLOR_NAMES, SKILL_ICON_INTENT_MAP, SKILL_ICON_BASE_ENTRIES, SKILL_ICON_CURATED_EXPORT_NAMES, SKILL_ICON_OPTION_IDS, toSkillIconOptionId };
